import React from 'react';
import {useSelector} from 'react-redux';

import {COLUMNS} from '../../constants';
import {useGetAccountSearchResultCrmUsers} from '../../hooks/useGetAccountSearchResultCrmUsers';
import {accountSearchResultResultSelector} from '../../slices/account-search-result.slice';

import {HeaderCaption} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';


type Props = {
    accountIds: number[],
    totalCount: number,
};

const CrmEnabledUsersHeaderController = ({accountIds, totalCount}: Props) => {
    const {isLoading, loadingError} = useGetAccountSearchResultCrmUsers({accountIds, totalCount});

    return (
        <HeaderCaption
            isLoading={isLoading}
            loadingError={loadingError}
            columnId={COLUMNS.CRM_ENABLED_USERS}
        />
    );
};

export const CrmEnabledUsersHeader = () => {
    const result = useSelector(accountSearchResultResultSelector);

    return result ? (
        <CrmEnabledUsersHeaderController
            accountIds={result.data.map(({accountId}) => accountId)}
            totalCount={result.totalCount}
        />
    ) : (
        <HeaderSkeleton columnId={COLUMNS.CRM_ENABLED_USERS}/>
    );
};
